<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100" v-if="isLoaded">
			<div class="sf-col sf-col-4 qms-multi-selection">
				<sf-card class="p-0 h-100 card_bg">
					<search-container ref="searchContainer" :scrId="scrId" />
				</sf-card>
			</div>
			<!--엑셀 업로드 팝업창 영역 시작-->
			<div class="sf-col sf-col-16">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-container ref="table" @PopupOpen="PopupOpen" @Refresh="Refresh" :scrId="scrId" />
					<excel-upload-modal :scrId="scrId" ref="excelUploadPop" @Refresh="Refresh" />
				</sf-card>
			</div>
			<!--엑셀 업로드 팝업창 영역 끝-->
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<form-container :scrId="scrId"></form-container>
				</sf-card>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/ptin/PowTourPrvsMng/store/helpers';
import SearchContainer from './Search/Search.vue';
import TableContainer from './Table/Table.vue';
import FormContainer from './Table/Form.vue';
import ExcelUploadModal from '@qms/Components/popup/ExcelUploadModal.vue'; //엑셀업로드 모달창
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			isLoaded: false
		};
	},
	components: { SearchContainer, TableContainer, FormContainer, ExcelUploadModal },
	async created() {
		try {
			this.$sf_toggleLoading(true);
			await this.getCommCodesOnce_(); // 한번에 공통 코드 부르기
			await this.setAllPowPrvsCdList_();
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error.message || error });
		} finally {
			this.isLoaded = true;
			this.$sf_toggleLoading(false);
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		Refresh() {
			//$refs 는 컴포넌트에 ref로 정의한 이름으로 접근할때 사용한다.
			this.$refs.searchContainer.searchList();
		},
		PopupOpen(param) {
			this.$refs.excelUploadPop.open(param); //ExcelUploadModal 팝업에 정의한 open팝업을 실행한다.
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed
	}
};
</script>

<style lang="scss">
.qms-multi-selection {
	.sf-card__content {
		height: 100%;
		overflow-y: hidden;
	}
}
</style>
